module.exports = __webpack_public_path__ + "static/media/header_news3555da5ca367dd5139862eca2fc544f0.webp";